module.exports = __webpack_public_path__ + "media/images/Press-mini-5fa1fbe697ac8ab8948f22595c19d66d.png";